import { render, staticRenderFns } from "./NonLiveCourses.vue?vue&type=template&id=3fd0c12d"
import script from "./NonLiveCourses.vue?vue&type=script&lang=ts"
export * from "./NonLiveCourses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports